import firebase, {db,auth} from './firebase'
// import moment from 'moment'

// const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp()



export default class DBHelper {
  /**********
   * auth user
   */
  static currentUser = () => {
    return firebase.auth().currentUser
  }
  static currentUid = () => {
    const currentUser = auth.currentUser
    return currentUser ? currentUser.uid : null
  }

  /********
   * Spaces
   */

  static getSpaces = () => {
    const ref = db.collection('/spaces')
    return ref.get().then(colSnap => colSnap.docs.map(doc => doc.data()))
  }

  /*******
   * users
   */

   static getUsers = (spaceId) => {
     const ref = db.collection(`/spaces/${spaceId}/users`)
     return ref.get().then(colSnap => colSnap.docs.map(doc => doc.data()))
   }

  /*******
   * groups
   */

   static getGroups = (spaceId) => {
    const ref = db.collection(`/spaces/${spaceId}/groups`)
    return ref.get().then(colSnap => colSnap.docs.map(doc => doc.data()))    
   }

  /**********
   * Application
   */

   static saveApplication = (data) => {
    const ref = db.doc(`/applications/${data.spaceId}`)
    return ref.set(data)
   }

   static getPasswords = (spaceId) => {
     const ref = db.collection(`/applications/${spaceId}/users`)
     return ref.get().then(colSnap => colSnap.docs.map(doc => doc.data()))
   }
}


// WEBPACK FOOTER //
// ./src/helpers/db.js